import { useCommonUserRetrieve } from "@boundless/bl-api-client/common/services"
import { UserIcon } from "lucide-react"

export function ImpersonationBar({ onLogout }: { onLogout: () => void }) {
  const { data: user, isSuccess } = useCommonUserRetrieve()

  if (!isSuccess || !user.isImpersonated) {
    return null
  }

  return (
    <div className="bg-warning border-warning-foreground flex h-7 max-h-7 flex-row items-center gap-2 border-b-[0.5px] p-2 px-5 text-xs">
      <UserIcon className="text-warning-foreground h-4 w-4" />
      <span>
        Viewing as <span className="font-bold">{user.email}</span>.{" "}
        <button className="cursor-pointer underline" onClick={onLogout}>
          Exit
        </button>
      </span>
    </div>
  )
}
